module.exports = __webpack_public_path__ + "img/LIGHTING 1 RED.ead7690.svg";